// change image url to:
// localhost:8080
// 0.0.0.0:8080
// or intervi.co

const people = [
  {
    image: "http://localhost:8080/static/img/intervi-13.2b27480.jpg",
    name: "Mariusz",
    profession: "Founder & CEO",
    profession_cd: ""
  },
  {
    image: "http://localhost:8080/static/img/intervi-2.bda8d9c.jpg",
    name: "Krysia",
    profession: "Copywriter",
    profession_cd: ""
  },
  {
    image: "http://localhost:8080/static/img/intervi-6.33adbdc.jpg",
    name: "Fabia",
    profession: "Ceo / Head Officer",
    profession_cd: ""
  },
  {
    image: "http://localhost:8080/static/img/intervi-10.388b8c4.jpg",
    name: "Aga",
    profession: "Photographer",
    profession_cd: ""
  },
  {
    image: "http://localhost:8080/static/img/intervi-3.4371ed4.jpg",
    name: "Grzesiek",
    profession: "Account executive",
    profession_cd: ""
  },
  {
    image: "http://localhost:8080/static/img/intervi-12.5efcea0.jpg",
    name: "Mateusz S.",
    profession: "Marketing specialist",
    profession_cd: ""
  },
  {
    image: "http://localhost:8080/static/img/intervi-1.689f2a3.jpg",
    name: "Kaśka",
    profession: "Front-end developer",
    profession_cd: ""
  },
  {
    image: "http://localhost:8080/static/img/intervi-7.9bddacb.jpg",
    name: "Artur",
    profession: "Senior graphic",
    profession_cd: "designer"
  },
  {
    image: "http://localhost:8080/static/img/intervi-14.1ec538b.jpg",
    name: "Marcin",
    profession: "Art director",
    profession_cd: ""
  },
  {
    image: "http://localhost:8080/static/img/intervi-11.28a5b67.jpg",
    name: "Oleksandr",
    profession: "Junior graphic",
    profession_cd: "designer"
  },
  {
    image: "http://localhost:8080/static/img/intervi-9.84db908.jpg",
    name: "Patryk",
    profession: "Junior graphic",
    profession_cd: "designer"
  },
  {
    image: "http://localhost:8080/static/img/intervi-8.c66cf3e.jpg",
    name: "Daria",
    profession: "Director, Social",
    profession_cd: "media marketing"
  },
  {
    image: "http://localhost:8080/static/img/intervi-5.0017de8.jpg",
    name: "Weronika",
    profession: "Project manager",
    profession_cd: ""
  },
  {
    image: "http://localhost:8080/static/img/intervi-4.ab2fa38.jpg",
    name: "Łukasz",
    profession: "Marketing specialist",
    profession_cd: ""
  }
  // {
  //   image: "http://localhost:8080/static/img/intervi-1.jpg",
  //   name: "Mateusz S.",
  //   profession: "Marketing specialist",
  //   profession_cd: ""
  // },
  // {
  //   image: "http://localhost:8080/static/img/intervi-1.jpg",
  //   name: "Patryk",
  //   profession: "Junior graphic",
  //   profession_cd: "designer"
  // }

];

export default people;



// WEBPACK FOOTER //
// ./src/assets/people.js